export const createWatchlistQuestion = ({
    id = createWatchlistQuestionId(),
    question = "",
    responseType = "Keyboard",
    responseOptions = [],
    isRequired = true
  } = {}) => {
    const normalizedResponseType =
      normalizeWatchlistQuestionResponseType(responseType);
  
    return {
      id,
  
      question,
  
      responseType:
        normalizedResponseType,
  
      responseOptions:
        cleanWatchlistResponseOptions(
          normalizedResponseType,
          responseOptions
        ),
  
      isRequired
    };
  };
  
  export const createBaseWatchlistQuestions =
    () => [
  
      createWatchlistQuestion({
        question:
          "Which company, product, or service was involved?",
        responseType:
          "Keyboard",
        isRequired:
          true
      }),
  
      createWatchlistQuestion({
        question:
          "Tell us what happened.",
        responseType:
          "LongText",
        isRequired:
          true
      }),
  
      createWatchlistQuestion({
        question:
          "When did this happen?",
        responseType:
          "Date",
        isRequired:
          false
      }),
  
      createWatchlistQuestion({
        question:
          "Where did this happen?",
        responseType:
          "Keyboard",
        isRequired:
          false
      }),
  
      createWatchlistQuestion({
        question:
          "How did this affect you?",
        responseType:
          "LongText",
        isRequired:
          true
      }),
  
      createWatchlistQuestion({
        question:
          "Have you contacted the company about this?",
        responseType:
          "YesNo",
        isRequired:
          false
      }),
  
      createWatchlistQuestion({
        question:
          "Is the issue still happening?",
        responseType:
          "YesNo",
        isRequired:
          false
      }),
  
      createWatchlistQuestion({
        question:
          "Is there anything else you think we should know?",
        responseType:
          "LongText",
        isRequired:
          false
      })
    ];
  
  export const cloneWatchlistQuestions =
    questions => {
  
      if (!Array.isArray(questions)) {
        return [];
      }
  
      return questions.map(
        question =>
          createWatchlistQuestion({
            id:
              String(
                question.id ?? ""
              ).trim() ||
              createWatchlistQuestionId(),

            question:
              question.question ?? "",
  
            responseType:
              normalizeWatchlistQuestionResponseType(
                question.responseType
              ),
  
            responseOptions:
              cleanWatchlistResponseOptions(
                question.responseType,
                question.responseOptions
              ),
  
            isRequired:
              question.isRequired ??
              true
          })
      );
    };
  
  export const cleanWatchlistQuestions =
    questions => {
  
      if (!Array.isArray(questions)) {
        return [];
      }
  
      return questions
        .filter(
          question =>
            String(
              question.question ?? ""
            ).trim() !==
            ""
        )
        .map(
          (
            question,
            index
          ) => ({
            id:
              String(
                question.id ?? ""
              ).trim() ||
              createWatchlistQuestionId(),
  
            order:
              index,
  
            question:
              String(
                question.question
              ).trim(),
  
            responseType:
              normalizeWatchlistQuestionResponseType(
                question.responseType
              ),
  
            responseOptions:
              cleanWatchlistResponseOptions(
                question.responseType,
                question.responseOptions
              ),
  
            isRequired:
              question.isRequired ??
              true
          })
        );
    };

export const watchlistQuestionResponseTypeValues = [
  "Keyboard",
  "LongText",
  "Number",
  "Date",
  "YesNo",
  "Options"
];

const watchlistQuestionResponseTypes = new Set(
  watchlistQuestionResponseTypeValues
);

const normalizeWatchlistQuestionResponseType = responseType => {
  const requestedType = String(responseType ?? "Keyboard").trim();

  return watchlistQuestionResponseTypes.has(requestedType) ?
    requestedType :
    "Keyboard";
};

const cleanWatchlistResponseOptions = (responseType, responseOptions) => {
  if (
    normalizeWatchlistQuestionResponseType(responseType) !== "Options" ||
    !Array.isArray(responseOptions)
  ) {
    return [];
  }

  return [...new Set(
    responseOptions
      .map(option => String(option ?? "").trim())
      .filter(Boolean)
  )];
};

const createWatchlistQuestionId = () => {
  const browserCrypto = window.crypto;

  if (typeof browserCrypto?.randomUUID === "function") {
    return browserCrypto.randomUUID();
  }

  if (typeof browserCrypto?.getRandomValues === "function") {
    const bytes = new Uint8Array(16);
    browserCrypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const value = [...bytes]
      .map(byte => byte.toString(16).padStart(2, "0"))
      .join("");

    return [
      value.slice(0, 8),
      value.slice(8, 12),
      value.slice(12, 16),
      value.slice(16, 20),
      value.slice(20)
    ].join("-");
  }

  return `watchlist-question-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
};
